import React, { useMemo, useState } from 'react'
import Text from '../text/Text'
import { Token, TransactionResponse } from '../../services/commerce'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import styles from './SaleComponent.module.css'
import { currencyFormat, parseStringDate } from '../../formatters'
import { useTokensContext } from '../../context/tokensContext'
import { labels } from '../../labels'
import useDisclosure from '../../hooks/useDisclosure'
import SaleModalComponent, {
    dateFormat,
    amiRutToken,
    codWebToken,
    codAppToken,
    qrToken,
    bciToken,
    ReverseModalState,
} from './../modal/SaleModal'

export const getTokenName = (token: string, tokens: Token[] | null) => {
    let tokenName = labels.amiMarket
    tokens?.forEach((item) => {
        if (item.idtoken === token) {
            if (item.idtoken === amiRutToken) {
                tokenName = labels.amiRut
            } else if (item.idtoken === codWebToken) {
                tokenName = labels.codWeb
            } else if (item.idtoken === codAppToken) {
                tokenName = labels.codApp
            } else if (item.idtoken === qrToken) {
                tokenName = labels.qr
            } else {
                tokenName = item.stexto2
            }
        } else if (token === bciToken) {
            tokenName = labels.bciPayment.bci
        }
    })
    return tokenName
}

interface ISaleComponentProps {
    sale: TransactionResponse
    handlerRefresh?: () => void
}

export default function SaleComponent({
    sale,
    handlerRefresh,
}: ISaleComponentProps) {
    const { open, handleOpen, handleClose } = useDisclosure()
    const tokens = useTokensContext()
    const [reverseState, setReverseState] = useState<ReverseModalState>(
        ReverseModalState.Inicial
    )

    const tokenName = useMemo(
        () => getTokenName(sale.sToken, tokens),
        [sale.sToken, tokens]
    )

    const truncateText = (text: string, maxLength = 12) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...'
        }
        return text
    }

    return (
        <>
            <SaleModalComponent
                open={open}
                handleClose={handleClose}
                sale={sale}
                tokens={tokens}
                reverseState={reverseState}
                updateReverseState={setReverseState}
                handlerRefresh={handlerRefresh}
            />

            <div
                onClick={handleOpen}
                className={`${styles.rowSale} ${styles.saleCard}`}
            >
                <div className={styles.column}>
                    <Text
                        textAlign="start"
                        label={`${tokenName} ${
                            tokenName === labels.bciPayment.bci
                                ? sale.sTypeSale + ' / '
                                : ' / '
                        }${sale.sEstadoTx}`}
                        variant="subtitle2 bold-600"
                    />
                    <Text
                        label={format(
                            parseStringDate(sale.dTransaccion),
                            dateFormat,
                            { locale: es }
                        )}
                        variant="Body2-14"
                    />
                </div>
                <div className={styles.columnId}>
                    <Text label="N°" variant="subtitle2 bold-600" />
                    <div
                        style={{
                            maxWidth: 80,
                        }}
                    >
                        <Text
                            label={String(
                                sale.authorizationCode &&
                                    sale.authorizationCode.trim() !== ''
                                    ? String(sale.authorizationCode)
                                    : sale.idTransaccion
                                    ? String(sale.idTransaccion)
                                    : ''
                            )}
                            variant="Body2-14"
                        />
                    </div>
                </div>
                <div className={styles.columnEnd}>
                    <p
                        className={`Body2-14 ${
                            // Clase "negative" si el monto es negativo
                            sale.nMonto.includes('-')
                                ? styles.negative
                                : // Clase "anulado" si cumple las condiciones (ANULADA + BCI/GETNET)
                                sale.sEstadoTx === 'ANULADA' &&
                                  (sale.sToken.includes('BCI') ||
                                      sale.sToken.includes('GETNET'))
                                ? styles.anulado
                                : '' // Sin clase adicional si no aplica
                        }`}
                    >
                        {currencyFormat(+sale.nMonto)}
                    </p>
                </div>
            </div>
        </>
    )
}
